import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { CombineLabelState } from "@redotech/redo-return-ui/flows/return-flow/combine-label";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useContext } from "react";
import { Link } from "react-router-dom";

export const CombineLabelDetails = memo(function CombineLabelDetails(
  _props: StepTypeDetailsProps<CombineLabelState>,
) {
  const team = useContext(TeamContext);

  const skuGroupingEnabled =
    team?.settings.returns?.labelCombination?.combineLabelsSkuGroups?.enabled ??
    false;
  const onlySameFulfillment =
    team?.settings.returns?.labelCombination
      ?.onlyCombineLabelsFromSameFulfillment ?? false;

  return (
    <Flex dir="column" gap="md">
      {!skuGroupingEnabled && !onlySameFulfillment && (
        <Text fontSize="xs" fontWeight="medium">
          • All items that are being returned to the same location will share a
          single shipping label.
        </Text>
      )}
      {(skuGroupingEnabled || onlySameFulfillment) && (
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Combination rules:
          </Text>
          {skuGroupingEnabled && (
            <Text fontSize="xs" fontWeight="medium">
              • Only items from your SKU groups will be combined
            </Text>
          )}
          {onlySameFulfillment && (
            <Text fontSize="xs" fontWeight="medium">
              • Only items that share a fulfillment will be combined
            </Text>
          )}
        </Flex>
      )}

      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        To update the combining rules, navigate to the{" "}
        <Link style={{ textDecoration: "underline" }} to="/settings/shipping">
          Label combination
        </Link>{" "}
        section in settings.
      </Text>

      <Text fontSize="xs" fontWeight="regular" mt="lg">
        This step will combine applicable products into one shipping label.
      </Text>
    </Flex>
  );
});
